import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var DecoratedIcon = function DecoratedIcon(_ref) {
  var Icon = _ref.Icon,
    sidebarCollapsed = _ref.sidebarCollapsed,
    iconColor = _ref.iconColor;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-flex tw-items-center tw-justify-center tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02 tw-border-solid tw-border-[0.5px] dark:tw-border-elevation-dark-04  tw-border-neutral-light-400', 'tw-rounded-[6px]', sidebarCollapsed ? 'tw-w-[36px] tw-h-[36px] hover:tw-bg-neutral-light-200 dark:hover:tw-bg-elevation-dark-03' : 'tw-w-[32px] tw-h-[32px]'),
    children: /*#__PURE__*/_jsx(Icon, {
      size: 24,
      className: iconColor
    })
  });
};